angular
  .module('company')

  .factory('HistoryCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class HistoryCrud extends Crud {
        constructor(list) {
          super(
            'signup' + (list || ''),
            '@@apiUrl' + '/task-history' + (list || '') + '/:id',
            { id: '@id' },
            {
              get: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return HistoryCrud;
    }
  ]);
